@if (flags.loading) {
  <mat-progress-bar mode="indeterminate" [class.iosProgress]="utils.ios()"></mat-progress-bar>
}
<div [style.background-image]="'url(./assets/img/background/' + bgImg + '.jpg)'" class="backgroundCoverFull backgroundFixed" [@zoomBack]=$safeNavigationMigration(user?.app_state?.homeBackground) (swiperight)="router.navigateByUrl('/messages')">
  <div fxlayout="row" class="homeComponent coverDark" [@fadeBackground]=$safeNavigationMigration(user?.app_state?.homeCover)>


    <button mat-button class="backBtn" [class.ios]="utils.ios()" [class.android]="utils.android()" routerLink="/messages"><mat-icon>arrow_back</mat-icon></button>
    <div class="header profile">
      <div fxlayout="row" class="item" [class.ios]="utils.ios()" [class.android]="utils.android()" [style.background-color]="conversationSelected?.meta?.to?.color + 'c7'" [class.lightMode]="$safeNavigationMigration(conversationSelected?.meta?.to?.color)|isLight">
        <div fxFlex class="text">
          <h2>{{conversationSelected?.meta?.names }}</h2>
          <!-- h4 for multiple names -->
          <p>{{$safeNavigationMigration(conversationSelected?.last_message)|slice:0:25 }}...</p>
          <h6 class="subHeading" [style.color]="conversationSelected?.meta?.to?.color">{{ $safeNavigationMigration(conversationSelected?.last_activity)|timeAgo}} ago &nbsp;
            <!-- <button mat-button (click)="archieveMessage(!conversationSelected.archived)" class="subHeading" [style.color]="conversationSelected?.meta?.to?.color">
            <mat-icon *ngIf="conversationSelected.archived">unarchive</mat-icon>
            <mat-icon *ngIf="!conversationSelected.archived">inventory</mat-icon>
          </button> -->
        </h6>
      </div>
      <div>
        <!-- <a routerLink="/{{conversationSelected?.meta?.to?.username}}">
        <img [src]="conversationSelected?.meta?.to?.thumbnail?.sm" class="zoomIn" *ngIf="conversationSelected?.meta?.to?.thumbnail?.sm" />
        <div class="noImage" *ngIf="!conversationSelected?.meta?.to?.thumbnail?.sm">{{conversationSelected?.meta?.to?.full_name}}</div>
      </a> -->
      <div class="border" [style.border-color]="conversationSelected?.meta?.to?.color" >
        <button routerLink="/{{conversationSelected?.meta?.to?.username}}" (click)="utils.sound('click-face')" [style.background-image]="getProfileBackground($safeNavigationMigration(conversationSelected?.meta?.to))" class="dropLet">
          @if (conversationSelected?.meta?.to?.is_premium && !conversationSelected?.meta?.to?.is_verified) {
            <mat-icon class="premium" [style.color]="conversationSelected?.meta?.to?.color">star</mat-icon>
          }
          @if (conversationSelected?.meta?.to?.is_premium && conversationSelected?.meta?.to?.is_verified) {
            <mat-icon class="premium" [style.color]="conversationSelected?.meta?.to?.color">fingerprint</mat-icon>
          }
          @if (conversationSelected?.meta?.to?.meta?.is_new) {
            <mat-icon class="new" [style.color]="conversationSelected?.meta?.to?.color">fiber_new</mat-icon>
          }
          <!-- <div class="counter" [class.lightMode]="conversationSelected?.meta?.to?.color|isLight" [style.background-color]="conversationSelected?.meta?.to?.color">{{conversationSelected?.meta?.to?.activities?.length}}</div> -->
        </button>
        @if (!conversationSelected?.meta?.to?.thumbnail?.sm) {
          <div class="noImage" routerLink="/{{conversationSelected?.meta?.to?.username}}" [style.border-color]="conversationSelected?.meta?.to?.color"  [style.color]="conversationSelected?.meta?.to?.color + '80'">{{$safeNavigationMigration(conversationSelected?.meta?.to?.full_name)|slice:0:2}}</div>
        }
      </div>
    </div>
  </div>
</div>

<div class="conversation profile" id="conversationFlow" (scroll)="onScroll($event)">
  <br clear="all" /><br clear="all" /><br clear="all" /><br clear="all" /><br clear="all" />
  @for (message of messages; track message; let first = $first) {
    <div>
      <div fxlayout="row" [class.from]="message?.sender?.id != user?.id" class="entry">
        @if (message?.sender?.id != user?.id) {
          <div [routerLink]="'/'+ $safeNavigationMigration(message?.sender?.username)">
            <!-- <div class="name" *ngIf="conversationSelected?.room_type != 'oneToOne'">{{ message?.sender?.full_name }}</div> -->
            @if (message?.sender?.thumbnail?.sm) {
              <img [src]="$safeNavigationMigration(message?.sender?.thumbnail?.sm)" [style.border]="'solid 2px ' + message?.sender?.color" />
            }
            @if (!message?.sender?.thumbnail?.sm) {
              <div class="noImage" [style.color]="conversationSelected?.meta?.to?.color + '80'">{{$safeNavigationMigration(message?.sender?.full_name)|slice:0:2}}</div>
            }
          </div>
        }
        <div fxFlex>
          <p [style.background]="'linear-gradient(295deg,' + message?.sender?.color + 'eb,' + message?.sender?.color + 'b3)'" [class.lightMode]="$safeNavigationMigration(message?.sender?.color)|isLight" [innerHtml]="$safeNavigationMigration(message?.message)|linkify" (press)="utils.copyText($safeNavigationMigration(message?.message))">
            <!-- {{message?.message }} -->
          </p>
          @if (first) {
            <div class="typing" [class.active]="typing">
              <p class="loading"></p>
            </div>
          }
        </div>
      </div>
    </div>
  }
  <br clear="all" /><br clear="all" /><br clear="all" /><br clear="all" /><br clear="all" /><br clear="all" />
  <br clear="all" /><br clear="all" /><br clear="all" />

  <br clear="all" />
</div>

<div class="footerNav">
  <div class="messageInput">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div fxLayout="row" fxLayoutAlign="space-evenly start">
        <div fxFlex="5">
        </div>
        <div fxFlex="65">
          <mat-form-field>
            <textarea matInput placeholder="Enter message" autocomplete="off" (click)="startTyping()" (keyup)="activateBtn($event);startTyping()" (change)="activateBtn($event)" type="text" class="form-control" formControlName="message" [ngClass]="{ 'is-invalid': flags.sfe && f.email.invalid }"></textarea>
            @if (f.message.hasError('serverError')) {
              <mat-error>
                <small>{{f.message.errors.serverError}}</small>
              </mat-error>
            }
            @if (f.message.hasError('message')) {
              <mat-error>
                <small>Invalid Message</small>
              </mat-error>
            }
            @if (f.message.hasError('required')) {
              <mat-error>
                <small>Message is required</small>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div fxFlex="30">
          <button class="sendBtn" [disabled]="flags.btnSubmit" [class.btnReady2]="!flags.btnSubmit" mat-button color="primary"><mat-icon>arrow_forward</mat-icon></button>
        </div>
      </div>
    </form>
  </div>
</div>





</div>